import React, { useState, useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import _isEqual from 'lodash.isequal';
import BannerWidget from '../BannerWidget/BannerWidget';
import { BannerHeader } from '../BannerWidget/BannerWidget.style';
import { Tabs } from '../Tabs/Tabs'
import './BannerWidget.scss';



// var bannerBenefitsTestData = {
//   "tabs": [
//     {
//      "name":"TOI+",
//      "type": "toip" 
//     },
//     {
//       "name":"TOI+ &amp; ePaper",
//       "type": "toipepaper" 
//      },
//      {
//       "name":"All access",
//       "type": "toipall" 
//      },
//   ],
//   "items": [
//     {
//       "imgmsid": "99954898",
//       "h1": "The Times of India ePaper",
//       "bullets": [
//         "The PDF version of daily newspaper"
//       ],
//       "ctaText": "Explore Now",
//       "ctaLink": "/toi-plus/plans",
//       "plans": {
//         "toip": null,
//         "toipepaper": 1,
//         "toipall": 1
//       },
//       "sn": 1,
//       "positions": {
//         "img": "left"
//       }
//     },
//     {
//       "imgmsid": "99954898",
//       "h1": "TOI Print Edition",
//       "bullets": [
//         "text yet to be updated"
//       ],
//       "ctaText": "Explore Now",
//       "ctaLink": "/toi-plus/plans",
//       "plans": {
//         "toip": null,
//         "toipepaper": 2,
//         "toipall": 2
//       },
//       "sn": 1,
//       "positions": {
//         "img": "right"
//       }
//     },
//     {
//       "imgmsid": "99954898",
//       "h1": "TOI Exclusives",
//       "bullets": [
//         "Exclusive stories with in-depth coverage across multiple topics, expert opinions and more"
//       ],
//       "ctaText": "Subscribe Now",
//       "ctaLink": "/toi-plus/plans",
//       "plans": {
//         "toip": 1,
//         "toipepaper": 3,
//         "toipall": 3
//       },
//       "sn": 1,
//       "positions": {
//         "img": "left"
//       }
//     },
//     {
//       "imgmsid": "99954898",
//       "h1": "Times Special podcasts",
//       "bullets": [
//         "Exclusive audio content for a comprehensive understanding of the whole story"
//       ],
//       "ctaText": "Subscribe Now",
//       "ctaLink": "/toi-plus/plans",
//       "plans": {
//         "toip": 2,
//         "toipepaper": 4,
//         "toipall": 4
//       },
//       "sn": 1,
//       "positions": {
//         "img": "right"
//       }
//     },
//     {
//       "imgmsid": "99954898",
//       "h1": "Curated Newsletter",
//       "bullets": [
//         "6 weekly newsletteres delivered to your inbox- Gender+, Health+, Wealth+, Education+, WorkLife+, WorldWatch+ "
//       ],
//       "ctaText": "Subscribe Now",
//       "ctaLink": "/toi-plus/plans",
//       "plans": {
//         "toip": 3,
//         "toipepaper": 5,
//         "toipall": 5
//       },
//       "sn": 1,
//       "positions": {
//         "img": "left"
//       }
//     },
//     {
//       "imgmsid": "99954898",
//       "h1": "Times Prime Subscription (1 Year)",
//       "bullets": [
//         "Unlock free subscriptions and exciting offers on 20+ premium brands"
//       ],
//       "ctaText": "Subscribe Now",
//       "ctaLink": "/toi-plus/plans",
//       "plans": {
//         "toip": 4,
//         "toipepaper": 6,
//         "toipall": 6
//       },
//       "sn": 1,
//       "positions": {
//         "img": "right"
//       }
//     },
//     {
//       "imgmsid": "99954898",
//       "h1": "95% lesser Ads",
//       "bullets": [
//         "Enjoy uninteruppted reading experience with minimal ads"
//       ],
//       "ctaText": "Subscribe Now",
//       "ctaLink": "/toi-plus/plans",
//       "plans": {
//         "toip": 5,
//         "toipepaper": 7,
//         "toipall": 7
//       },
//       "sn": 1,
//       "positions": {
//         "img": "left"
//       }
//     },
//     {
//       "imgmsid": "99954898",
//       "h1": "Complete Access to ET Prime",
//       "bullets": [
//         "Get all of ET Prime including ET Exclusives and 5 daily newsletters"
//       ],
//       "ctaText": "Subscribe Now",
//       "ctaLink": "/toi-plus/plans",
//       "plans": {
//         "toip": 5,
//         "toipepaper": 7,
//         "toipall": 7
//       },
//       "sn": 1,
//       "positions": {
//         "img": "right"
//       }
//     }
//   ]
// };

// var unifiedNodesTestData = {
//   "notLoggedIn": {
//     "type": "newPlanpage",
//     "dealCode": "dealCode",
//     "planGroup": "annual,monthly",
//     "planGroupAutoSelected": "annual",
//     "planCodeAutoSelected": "toiPlusProMax",
//     "nudgePlanGroupAutoSelected": "annual",
//     "nudgePlanCodeAutoSelected": "toiPlusPro",
//     "otherPlanCodes": "CORP,STUD,WOMEN",
//     "ctaLink": "https://buy.indiatimes.com/toi/plans/"
//   },
//   "prc0": {
//     "type": "newPlanpage",
//     "dealCode": "dealCode",
//     "planGroup": "annual,monthly",
//     "planGroupAutoSelected": "annual",
//     "planCodeAutoSelected": "toiPlusProMax",
//     "nudgePlanGroupAutoSelected": "annual",
//     "nudgePlanCodeAutoSelected": "toiPlusPro",
//     "otherPlanCodes": "CORP,STUD,WOMEN",
//     "ctaLink": "https://buy.indiatimes.com/toi/plans/"
//   },
//   "prc1": {
//     "type": "newPlanpage",
//     "dealCode": "dealCode",
//     "planGroup": "annual,monthly",
//     "planGroupAutoSelected": "annual",
//     "planCodeAutoSelected": "toiPlusProMax",
//     "nudgePlanGroupAutoSelected": "annual",
//     "nudgePlanCodeAutoSelected": "toiPlusPro",
//     "otherPlanCodes": "CORP,STUD,WOMEN",
//     "ctaLink": "https://buy.indiatimes.com/toi/plans/"
//   },
//   "prc5": {
//     "type": "newPlanpage",
//     "dealCode": "dealCode",
//     "planGroup": "annual,monthly",
//     "planGroupAutoSelected": "annual",
//     "planCodeAutoSelected": "toiPlusProMax",
//     "nudgePlanGroupAutoSelected": "annual",
//     "nudgePlanCodeAutoSelected": "toiPlusPro",
//     "otherPlanCodes": "CORP,STUD,WOMEN",
//     "ctaLink": "https://buy.indiatimes.com/toi/plans/"
//   },
//   "prc6": {
//     "type": "newPlanpage",
//     "dealCode": "dealCode",
//     "planGroup": "annual,monthly",
//     "planGroupAutoSelected": "annual",
//     "planCodeAutoSelected": "toiPlusProMax",
//     "nudgePlanGroupAutoSelected": "annual",
//     "nudgePlanCodeAutoSelected": "toiPlusPro",
//     "otherPlanCodes": "CORP,STUD,WOMEN",
//     "ctaLink": "https://buy.indiatimes.com/toi/plans/"
//   },
//   "prc7": {
//     "type": "newPlanpage",
//     "dealCode": "dealCode",
//     "planGroup": "annual,monthly",
//     "planGroupAutoSelected": "annual",
//     "planCodeAutoSelected": "toiPlusProMax",
//     "nudgePlanGroupAutoSelected": "annual",
//     "nudgePlanCodeAutoSelected": "toiPlusPro",
//     "otherPlanCodes": "CORP,STUD,WOMEN",
//     "ctaLink": "https://buy.indiatimes.com/toi/plans/"
//   },
//   "grace": {
//     "type": "newPlanpage",
//     "dealCode": "dealCode",
//     "planGroup": "annual,monthly",
//     "planGroupAutoSelected": "annual",
//     "planCodeAutoSelected": "toiPlusProMax",
//     "nudgePlanGroupAutoSelected": "annual",
//     "nudgePlanCodeAutoSelected": "toiPlusPro",
//     "otherPlanCodes": "CORP,STUD,WOMEN",
//     "ctaLink": "https://buy.indiatimes.com/toi/plans/"
//   },
//   "preExpiry": {
//     "type": "newPlanpage",
//     "dealCode": "dealCode",
//     "planGroup": "annual,monthly",
//     "planGroupAutoSelected": "annual",
//     "planCodeAutoSelected": "toiPlusProMax",
//     "nudgePlanGroupAutoSelected": "annual",
//     "nudgePlanCodeAutoSelected": "toiPlusPro",
//     "otherPlanCodes": "CORP,STUD,WOMEN",
//     "ctaLink": "https://buy.indiatimes.com/toi/plans/"
//   }
// }

interface IBenefitsBannerData {
  wu: string;
  type: string;
  hl: string;
  id: number;
}

interface IBenefitsBannerComponentProps {
  data?: IBenefitsBannerData;
  cardStyle?: any;
  cachedData?: any;
  state?: any;
  bannerData?: any;
  unifiedNodes?: any;
  fireGA?: any;
  storyTitle?: any;
  msid?: any;
  isWapView?: boolean;
  hideCTA?: boolean;
}

const bannerHeaderStyle = {
  bannerHeaderStyle: {
    fontSize: '40px',
    lineHeight: '48px',
    textAlign: 'center',
    marginBottom: '20px',
    logoWidth: '120px',
    IpadfontSize: '48px',
    IpadlineHeight: '60px',
    IpadlogoWidth: '120px',
  },
}

const bannerHeaderStyleMobile = {
  bannerHeaderStyle: {
    fontSize: '20px',
    lineHeight: '28px',
    textAlign: 'center',
    marginBottom: '16px',
    logoWidth: '68px'
  },
}

const BannerBenefits = (props: IBenefitsBannerComponentProps) => {
  const { bannerData, fireGA, msid, storyTitle, isWapView, hideCTA, unifiedNodes } = props;
  const [selectedTab, setSelectedTab] = useState();
  const [updatedBannerData, setUpdatedBannerData] = useState<any>([]);

  useEffect(() => {
    if (bannerData?.items) {
      setUpdatedBannerData(bannerData.items);
      setSelectedTab(Array.isArray(bannerData.tabs) && bannerData.tabs[bannerData.tabs.length - 1]?.type)
    }
  }, [bannerData]);

  const getFilteredData = (items: any, tabData: any) => {
    return Array.isArray(items) && items.filter((innerItem) => innerItem.plans?.[tabData?.type])
  }

  const sortDataByValue = (items: any, tabData: any) => {
    return Array.isArray(items) && items.sort((innerItemFirst, innerItemSecond) => innerItemFirst.plans?.[tabData?.type] - innerItemSecond.plans?.[tabData?.type])
  }

  const tabChangeHandler = (tabData: any) => {
    setSelectedTab(tabData.type);
    const filteredData = getFilteredData(bannerData.items, tabData);
    const sortedData = sortDataByValue(filteredData, tabData);
    setUpdatedBannerData(sortedData);
  }
  return (
    <div className="bannerBenefitsWrapper">
      <BannerHeader styles={isWapView ? bannerHeaderStyleMobile : bannerHeaderStyle}>{bannerData.h1}</BannerHeader>
      <Tabs data={bannerData.tabs} onTabChange={tabChangeHandler} active={selectedTab} />
      {Array.isArray(updatedBannerData) && updatedBannerData.map((data: any, index: number) => (
        <BannerWidget data={data} fireGA={fireGA} msid={msid} unifiedNodes={unifiedNodes}
          storyTitle={storyTitle} index={data.plans?.[selectedTab || -1] || 0} isWapView={isWapView} hideCTA={hideCTA} totalLength={updatedBannerData.length} />
      ))}
    </div>
  );
};


const mapStateToProps = (state: any) => ({
  unifiedNodes: _get(state, 'translationConfig.nudges.unifiedNodes', {}),
  bannerData: _get(state, 'translationConfig.nudges.bannerBenefits', {}),
});

export default connect(mapStateToProps)(BannerBenefits);
